import React, { Component } from "react";
import { Form, Field } from "redux-form";

class SecuritySigninForm extends Component {
  render() {
    const { error, handleSubmit } = this.props;

    return (
      <Form onSubmit={handleSubmit}>
        {error && <div className="form__error">{error}</div>}
        <Field
          className="form__field"
          name="email"
          component="input"
          type="text"
          placeholder="e-mail"
        />
        <Field
          className="form__field"
          name="password"
          component="input"
          type="password"
          placeholder="mot de passe"
        />
        <button className="button" type="submit">
          Se connecter
        </button>
      </Form>
    );
  }
}

export default SecuritySigninForm;



// WEBPACK FOOTER //
// ./src/components/forms/SecuritySigninForm.js